import React from 'react'
import {Box, Image,HStack,Link, Text} from '@chakra-ui/react'

const Cta = () => {
  return (
    <Box bg='#246BFD' w='full' h='100vh' gap='6' display='flex' justifyContent='center' flexDirection={['column-reverse','row']} alignItems='center' p={['1rem', '1.5rem','2rem','4rem']}>
        <Box w={['100%','50%']} display={['none','block']} >
            <Image m='auto' w='45%' h='100%' src='/iPhone.svg'alt='mobile'/>
        </Box>
        <Box w={['100%','50%']} mt='1.5rem' display={['block','none']}>
            <Image m='auto' w='45%' h='100%' src='/ctasmall.png'alt='mobile'/>
        </Box>
        <Box w={['100%','50%']} float='left' mr={['none','none','none','2rem']} px='1rem' >
        <Text fontSize={['24px','1.5rem','1.75rem','3rem']} color='#fff' textAlign={['center','']}  lineHeight={['32px','32px','32px','72px']} fontFamily='Duplicate Sans' fontWeight='500'>
        Experience seamlessness
with NeemblePay
        </Text>
        <Text fontFamily='Work Sans' fontSize={['12.5px','1rem']} lineHeight={['24px','28px']}  mt='1rem'  color='#fff'>It only takes a few minutes to start enjoying fast and easy payment 
service. Download NeemblePay on Google Play or App Store.</Text>
        <HStack mt='1rem' align='center' justify='center' gap={['4','2','2','2']}>
                <Link><Image src='/google.png' w={['135px','']} h={['52px','']} alt='socials'/></Link>
                <Link><Image src='/apple.png'  w={['135px','']} h={['52px','']} alt='socials'/></Link>
            </HStack>
        </Box>
    </Box>
  )
}

export default Cta